<template>
    <div class="modal-window" v-if="player || share">
        <CampaignPlayer v-if="player" :id="player_id" @close="player = false"/>

        <CampaignShare v-if="share" :id="player_id" :shareId="shareId" :isEdit="isEdit" @close="share = false"/>
    </div>

    <painel-component :items="itemsOne">
        <form>
            <row-component>
                <row-col-component class-row-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <label>Nome:</label>
                    <input-component v-model="formData.name" type-input="text"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <label>Empresa:</label>
                    <Multiselect label="name" v-model="formData.company_id" :options="selectCompanyList"
                                 :searchable="true" :noResultsText="noResultsText" :noOptionsText="noOptionsText"/>
                </row-col-component>

                <row-col-component v-if="isClient"
                                   class-row-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                    <button-submit @click="submit" icon="search"/>
                    <button-route v-if="buttonCheck.create" :items="itemsTwo"/>
                </row-col-component>
            </row-component>
        </form>

        <div class="alert alert-warning" role="alert" v-if="!isClient">
            <i class="exclamation triangle icon"></i>
            Selecione um cliente
        </div>

        <table class="table table-striped" v-if="showLoader && isClient">
            <thead>
            <tr>
                <th scope="col" style="width: 40%">Nome</th>
                <th scope="col" style="width: 40%">Empresa</th>
                <th scope="col" style="width: 20%">Ações</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(data, index) in object.data" :key="index">
                <td data-label="Nome">{{ data.name }}</td>
                <td data-label="Empresa">{{ data.company_name }}</td>
                <td data-label="Ações" v-if="buttonCheck.edit || buttonCheck.show">
                    <button-submit class="me-2" icon="play" @click="playerAdd(data.id)"/>
                    <button-submit :class="{'bg-info' : data.share}" icon="map marker alternate"
                                   @click="shareCampaign(data)"/>
                    <button-edit v-if="buttonCheck.edit" :id="data.id" route="campaign-edit"/>
                    <button-delete v-if="buttonCheck.delete" @click="destroy(data)"/>
                </td>
            </tr>
            </tbody>
        </table>

        <button-pagination v-if="isClient" :pagination="object" :offset="3" @paginate="loadItems"/>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import InputComponent from "@/components/form/InputComponent";
import Multiselect from "@vueform/multiselect";
import ButtonSubmit from "@/components/buttons/ButtonSubmit";
import ButtonRoute from "@/components/buttons/ButtonRoute";
import ButtonEdit from "@/components/buttons/ButtonEdit";
import ButtonPagination from "@/components/buttons/ButtonPagination";
import CampaignPlayer from "@/views/search/CampaignPlayer";
import ButtonDelete from "@/components/buttons/ButtonDelete";
import {useToast} from "vue-toastification";
import swal from "sweetalert";
import CampaignShare from "@/views/search/CampaignShare.vue";

const toast = useToast()
export default {
    name: "CampaignSearch",
    components: {
        CampaignShare,
        ButtonDelete,
        CampaignPlayer,
        ButtonPagination,
        ButtonEdit,
        ButtonRoute,
        ButtonSubmit,
        Multiselect,
        InputComponent,
        RowColComponent,
        RowComponent,
        PainelComponent
    },

    created() {
        this.$store.dispatch("changeNamePage", "Campanha")
        this.checkACL()
        this.loadStorage()
        this.loadItems(1)
    },

    data() {
        return {
            itemsOne: {
                title: "Pesquisar",
                icon: "list alternative"
            },

            itemsTwo: {
                icon: "plus",
                route: "/campaign/create"
            },

            buttonCheck: {
                create: false,
                edit: false,
                delete: false,
            },

            formData: {
                name: "",
                company_id: ""
            },

            isEdit: "",
            shareId: "",
            share: false,
            player: false,
            player_id: "",

            showLoader: false,
            searchSubmit: false
        }
    },

    methods: {
        submit() {
            this.loadItems(1)
            this.searchSubmit = true;
        },

        loadItems(page) {
            if (this.isClient) {
                if (!this.searchSubmit) {
                    this.$store.dispatch("loadCampaigns", {...this.params, page})
                        .then((r) => {
                            if (this.searchSubmit) {
                                this.searchSubmit = false;
                                if (r.data.length === 0) {
                                    toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 1200});
                                }
                            }
                        }).catch(() => {
                        this.searchSubmit = false;
                    });
                }
            }
        },

        loadStorage() {
            this.$store.commit("IS_CLIENT", this.convertBool(localStorage.getItem("isClient")))
            this.$store.commit("ID_CLIENT", localStorage.getItem("id_client"))
            this.$store.dispatch("loadCompanyList", localStorage.getItem("id_client"))
        },

        convertBool(string) {
            return string === "true";
        },

        async checkACL() {
            this.$store.dispatch('ACLItemsNav')
                .then((r) => {
                    if (r.data.indexOf('campaing-search') !== -1) {
                        this.showLoader = true
                        if (r.data.indexOf('campaing-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('campaing-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('campaing-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('campaing-delete') !== -1) {
                            this.buttonCheck.delete = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        destroy(item) {
            swal({
                title: 'Atenção!',
                text: `Deseja realmente deletar ${item.name} ?`,
                closeOnClickOutside: false,
                buttons: {
                    cancel: {
                        text: 'Não',
                        visible: true,
                        closeModal: true,
                    },
                    confirm: "Sim"
                }
            }).then((result) => {
                if (result) {
                    let params = {
                        id: item.id,
                        client_id: this.idClient
                    }
                    this.$store.dispatch('destroyCampaign', params).then(() => {
                        this.loadItems(1)
                        toast.success("Campanha deletada com sucesso", {timeout: 1200});
                    }).catch(() => {
                        toast.error(`Não foi possível deletar  ${item.name} `, {timeout: 1200});
                    })
                }
            });
        },

        playerAdd(id) {
            this.player_id = id
            this.player = !this.player
        },

        shareCampaign(data) {
            this.player_id = data.id
            this.isEdit = data.share
            this.shareId = data.shareID
            this.share = true
        }
    },

    computed: {
        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        isClient() {
            return this.$store.state.var.isClient
        },

        idClient() {
            return this.$store.state.var.idClient
        },

        selectCompanyList() {
            return this.$store.state.var.selectCompanyList
        },

        object() {
            return this.$store.state.campaign.items
        },

        params() {
            return {
                name: this.formData.name,
                company_id: this.formData.company_id,
                client_id: this.idClient
            }
        }
    },

    watch: {
        idClient(old, newValue) {
            this.loadItems(1)
            this.formData.client_id = newValue
        }
    }
}
</script>

<style scoped>

.modal-window {
    top: 0;
    left: 0;
    z-index: 25;
    width: 100vw;
    height: 100vh;
    display: grid;
    position: fixed;
    place-items: center;
    background: rgba(0, 0, 0, 0.7);
}

</style>